import ReportTypes from './types';

export const initialStates = {
	couponsTransactions: null,
	couponsTransactionsOverview: null,
	paymentRequestTransactionsOverview: null,
	paymentRequestTransactions: null,
	transactionPackageList: {},
	chartPackageList: {},
	chartPackageOffcbList: {},
	transactionPackageListOffcb: {
		start_date: null,
		end_date: null,
		total_of_page: 0,
		meta: {
			current_page: 0,
			first_page: 0,
			last_page: 0,
			per_page: 0,
			total_data: 0,
		},
		data: [],
	},
};

const reportsReducers = (state = initialStates, action) => {
	switch (action.type) {
		case ReportTypes.COUPON_TRANSACTIONS.SUCCESS: {
			return { ...state, couponsTransactions: action?.payload };
		}

		case ReportTypes.COUPON_TRANSACTIONS.CLEAR: {
			return { ...state, couponsTransactions: null };
		}

		case ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.SUCCESS: {
			return { ...state, couponsTransactionsOverview: action?.payload };
		}

		case ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.CLEAR: {
			return { ...state, couponsTransactionsOverview: null };
		}

		case ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.SUCCESS: {
			return { ...state, paymentRequestTransactionsOverview: action?.payload };
		}

		case ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.CLEAR: {
			return { ...state, paymentRequestTransactionsOverview: null };
		}

		case ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.SUCCESS: {
			return { ...state, paymentRequestTransactions: action?.payload };
		}

		case ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.CLEAR: {
			return { ...state, paymentRequestTransactions: null };
		}
		case ReportTypes.REPORT_TRANSACTIONS_PACKAGE.SUCCESS: {
			return { ...state, transactionPackageList: action?.payload };
		}
		case ReportTypes.REPORT_TRANSACTIONS_PACKAGE.CLEAR: {
			return { ...state, transactionPackageList: [] };
		}
		case ReportTypes.REPORT_CHART_PACKAGE.SUCCESS: {
			return { ...state, chartPackageList: action?.payload };
		}
		case ReportTypes.REPORT_CHART_PACKAGE.CLEAR: {
			return { ...state, chartPackageList: {} };
		}
		case ReportTypes.REPORT_CHART_PACKAGE_OFFCB.SUCCESS: {
			return { ...state, chartPackageOffcbList: action?.payload };
		}
		case ReportTypes.REPORT_CHART_PACKAGE_OFFCB.CLEAR: {
			return { ...state, chartPackageOffcbList: {} };
		}
		case ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.SUCCESS: {
			const { offcb_details: newDetails } = action?.payload;
			const isNewDate = state.transactionPackageListOffcb?.data?.length === 0;
			return {
				...state,
				transactionPackageListOffcb: {
					...newDetails,
					data: isNewDate
						? [...(newDetails?.data || [])]
						: [
								...(state.transactionPackageListOffcb?.data || []),
								...(newDetails?.data || []),
						  ],
				},
			};
		}
		case ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.CLEAR: {
			return {
				...state,
				transactionPackageListOffcb: {
					start_date: null,
					end_date: null,
					total_of_page: 0,
					meta: {
						current_page: 0,
						first_page: 0,
						last_page: 0,
						per_page: 0,
						total_data: 0,
					},
					data: [],
				},
			};
		}

		default:
			return state;
	}
};

export default reportsReducers;
